'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var styles = require('./index.module.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styles__default = /*#__PURE__*/_interopDefaultLegacy(styles);

var Loader = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId;
    return (React__default['default'].createElement("svg", { height: '24', width: '24', viewBox: '0 0 24 24', className: cn__default['default'](styles__default['default'].component, className), "data-test-id": dataTestId },
        React__default['default'].createElement("circle", { cx: '4', cy: '12', r: '2' }),
        React__default['default'].createElement("circle", { cx: '12', cy: '12', r: '2' }),
        React__default['default'].createElement("circle", { cx: '20', cy: '12', r: '2' })));
};

exports.Loader = Loader;
